


















































import { Component, Prop, Mixins } from "vue-property-decorator";
import CurrenciesStore from "@/mixins/constants/currenciesStore";

@Component
export default class ProviderCurrenciesList extends Mixins(CurrenciesStore) {
  @Prop({ required: true })
  public isProcessing!: boolean;

  @Prop({ required: true })
  public value!: string[];

  // Data

  public query = "";

  // Computed

  public get selected() {
    return this.value;
  }

  public set selected(value) {
    this.$emit("input", value);
  }

  public get filteredCurrencies() {
    const query = this.query.trim().toUpperCase();
    const filtered = query.length
      ? this.$_.filter(this.currencies, ({ code }) => code.includes(query))
      : this.currencies;
    return this.$_.orderBy(filtered, ["code"], ["asc"]);
  }

  public get canSelectAll() {
    return this.value?.length < this.currencies?.length;
  }

  // Methods

  public clearFilter() {
    this.query = "";
  }

  public toggleAll() {
    this.clearFilter();
    const all = this.$_.map(this.currencies, "id");
    this.$emit("input", this.canSelectAll ? all : []);
  }
}
